var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingsPage',{attrs:{"title":"Administrationsbereich"}},[_c('SmartButton',{on:{"click":_vm.pleaseFail}},[_vm._v("throws error")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }